var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Contact Information")]),_c('ClientPeopleAppendix',{model:{value:(_vm.form.people),callback:function ($$v) {_vm.$set(_vm.form, "people", $$v)},expression:"form.people"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }